/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/user/user.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { UserRoutingModule } from "./user-routing.module";
import * as i0 from "@angular/core";
export class UserModule {
    constructor() {
    }
}
UserModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    UserRoutingModule,
                ],
            },] },
];
/** @nocollapse */
UserModule.ctorParameters = () => [];
/** @nocollapse */ UserModule.ɵmod = i0.ɵɵdefineNgModule({ type: UserModule });
/** @nocollapse */ UserModule.ɵinj = i0.ɵɵdefineInjector({ factory: function UserModule_Factory(t) { return new (t || UserModule)(); }, imports: [[
            UserRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UserModule, { imports: [UserRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UserModule, [{
        type: NgModule,
        args: [{
                imports: [
                    UserRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC91c2VyL3VzZXIubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMsaUJBQWlCLEVBQUMsTUFBTSx1QkFBdUIsQ0FBQzs7QUFPeEQsTUFBTSxPQUFPLFVBQVU7SUFDckI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixpQkFBaUI7aUJBQ2xCO2FBQ0Y7Ozs7OENBQ1ksVUFBVTttR0FBVixVQUFVLGtCQUpYO1lBQ1IsaUJBQWlCO1NBQ2xCO3dGQUVVLFVBQVUsY0FIbkIsaUJBQWlCO2tEQUdSLFVBQVU7Y0FMdEIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixpQkFBaUI7aUJBQ2xCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtVc2VyUm91dGluZ01vZHVsZX0gZnJvbSBcIi4vdXNlci1yb3V0aW5nLm1vZHVsZVwiO1xuXG5ATmdNb2R1bGUoe1xuICBpbXBvcnRzIDogW1xuICAgIFVzZXJSb3V0aW5nTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBVc2VyTW9kdWxlIHtcbiAgY29uc3RydWN0b3IoKSB7fVxufVxuIl19